import { DecodedDataTable } from '@app/features/decoded-data/models/decoded-data-table.model';
import { Division } from '@app/features/division/models/division.interface';
import { Translation } from '@app/shared/models/translation/translation.interface';
import { HierarchyType, NodeTypeMode, NodeTypeTag } from './hierarchy.constants';

export interface AbstractHierarchyDto {
  id: string;
  description: string;
  type: HierarchyType;
  icon: string;
  mainUserHierarchy?: boolean;
}

export interface HierarchyDivisionDto {
  id: string;
  hierarchyId: string;
  division: Division;
}

export interface GetHierarchyDto extends AbstractHierarchyDto {
  nodeTypes: NodeTypeDto[];
  divisions: HierarchyDivisionDto[];
  b2bCatalog: boolean;
}

/*export interface GetHierarchyFull extends AbstractHierarchyDto {
  nodeTypes: NodeTypeDto[];
  divisions: Division[];
}*/

export interface FormHierarchyDto extends AbstractHierarchyDto {
  nodeTypeIds: string[];
  divisions: string[];
  b2bCatalog: boolean;
}

export interface NodeTypeDto {
  id: string;
  mode: NodeTypeMode;
  nodeTag: NodeTypeTag;
  description: string;
  icon: string;
  available: boolean;
  tableName: string;
  codeField: string;
  descriptionField: string;
  serviceId: string;
  divisionField: string;
  hierarchyUsage?: number;
  decodedDataTable?: DecodedDataTable;
  b2bCatalogLevel?: number;
  b2bCatalogImageMode?: boolean;
}

export interface FormNodeDto {
  id: string;
  // TODO: uncomment when used
  // nodeElementId: string;
  nodeElementDescription: string;
  // nodeElementDescriptionTranslation?: Translation;
}

export interface NodeDto {
  id: string;
  hierarchyId: string;
  nodeTypeId: string;
  parentId: string;
  nodeElementId: string;
  name: string;
  icon: string;
  childrenCount: number;
  nodeElementDescription: string;
  nodeElementDescriptionTranslation: Translation;
}

export interface NodeElementDto {
  id: string;
  description: string;
  descriptionTx: Translation;
}

export interface NodeMovementDto {
  childId: string;
  parentId: string;
}

export interface RefreshTreeDto {
  initialized: boolean;
  concessionDate: string;
  expirationDate: string;
}

export interface NodeElementColumn {
  id: string;
  txId: string;
}

export interface HierarchyTypeServiceDto {
  serviceId: string;
  keyValue: string;
  nodeTag: NodeTypeTag;
  additionalColumns: NodeElementColumn[];
}

export interface CheckedActions {
  [name: string]: boolean;
}

export class TreeNode {
  constructor(
    public item: NodeDto,
    public level = 0,
    public childrenCount = 0,
    public isLoading = false,
    public isLoadMore = false,
    public state: TreeNodeState = null
  ) {}
}

export class TreeNodeState {
  constructor(
    public page = 0,
    public size = 10,
    public column = 'nodeElementDescription',
    public direction = 'asc',
    public filter = ''
  ) {}
}
